<!-- 上传上传/下载列表 -->
<template>
  <div class="main">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="fileName" suffix-icon="el-icon-search" placeholder="搜索文件名称" clearable
        @change="onSearch"></el-input>
      <!-- <el-select v-model="status" placeholder="选择状态" @change="onSearch" clearable>
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip prop="fileName" label="文件名称"></el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip prop="createdTime" label="上传/下载时间"></el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip prop="bizType" label="上传/下载类型">
          <template slot-scope="scope">
            <span v-if="scope.row.bizType == 0">游学活动已购用户导出</span>
            <span v-if="scope.row.bizType == 1">问卷数据导出</span>
          </template>
        </el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip prop="userName" label="用户名称"></el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip prop="dealStatus" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.dealStatus == 0">处理中</span>
            <span v-if="scope.row.dealStatus == 1">处理成功</span>
            <span v-if="scope.row.dealStatus == 2">处理失败</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="downloadTemplate(scope.row)"
              v-if="scope.row.dealStatus != 0">下载文件</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileName: "",
      status: "",
      statusOptions: [
        {
          value: "0",
          label: "处理中",
        },
        {
          value: "1",
          label: "处理成功",
        },
        {
          value: "2",
          label: "处理失败",
        },
      ],
      tableData: [], //表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectUploadInfoPage()
  },

  methods: {
    // 获取列表
    selectUploadInfoPage() {
      this.loading = true
      this.$axios
        .post(this.$api.selectUploadInfoPage, {
          fileName: this.fileName || null,
          // dealStatus: this.status || null,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.desc)
        })
    },
    // 下载
    downloadTemplate(row) {
      const link = document.createElement("a")
      link.style.display = "none"
      link.href = row.fileUrl
      link.download = row.fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    onSearch() {
      this.clearData()
      this.selectUploadInfoPage()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectUploadInfoPage()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectUploadInfoPage()
    },
  },
}
</script>

<style scoped lang="scss">
.main {}
</style>
